import SharedItemsList from './shared-items/SharedItemsList.vue';
import BundleInfoCard from './shared-items/BundleInfoCard.vue';
import NumberSelected from './components/NumberSelected.vue';
import FailureReasons from './components/errors/FailureReasons.vue';
import InstallRequestId from './install/components/InstallRequestId.vue';
import InstallModal from './install/components/InstallModal.vue';
import SingleAppInstallModal from './install/components/SingleAppInstallModal.vue';
import InstallRequest from './install/components/request/InstallRequest.vue';
import BatchInstallRequestModal from './install/components/request/batch/BatchInstallRequestModal.vue';
import FailureReason from './components/errors/FailureReason.vue';
import FailureInlineAlert from './components/errors/FailureInlineAlert.vue';
import ExpandedError from './components/errors/dependency-path/ExpandedError.vue';
import DependencyPathDetail from './components/errors/dependency-path/DependencyPathDetail.vue';
import DependencyPathDetails from './components/errors/dependency-path/DependencyPathDetails.vue';
import { useError } from './components/errors/useError';
import { useTypeLabel } from './components/useTypeLabel';
import contentSharingLibMessages from './i18n/en-us.json';
import ShareItemProgress from './components/ShareItemProgress.vue';
import ImageWrapper from './components/ImageWrapper.vue';
import CopyText from './components/CopyText.vue';
import CopyableTooltipText from './components/CopyableTooltipText.vue';
import { useShareUrlsStore } from './stores/shareUrls';
import { useInstallRequestStore } from './stores/request';
import { useFeaturesStore } from './stores/features';
import { ACTIVE_UI } from './constants/share.links.constants';
import { generateTraceParentId } from './utils/api.util';

export function createLibrary(options = {}) {
    const library = {
        install() {
            const shareUrls = useShareUrlsStore();

            shareUrls.setPackagingServiceUrl(options.packagingServiceUrl);
            shareUrls.setWebUrl(options.webUrl);
            shareUrls.setUltimateUrl(options.ultimateUrl);
            shareUrls.setClassicUrl(options.classicUrl);
        },
    };

    return library;
}

export * from './constants/share.constants';
export * from './constants/features.constants';

export {
    contentSharingLibMessages,
    SharedItemsList,
    BundleInfoCard,
    NumberSelected,
    FailureReasons,
    FailureReason,
    FailureInlineAlert,
    ExpandedError,
    DependencyPathDetail,
    DependencyPathDetails,
    useError,
    useTypeLabel,
    useInstallRequestStore,
    useFeaturesStore,
    InstallModal,
    InstallRequestId,
    SingleAppInstallModal,
    BatchInstallRequestModal,
    ShareItemProgress,
    ImageWrapper,
    InstallRequest,
    CopyText,
    CopyableTooltipText,
    ACTIVE_UI,
    generateTraceParentId,
};
